import React, { FC } from "react";
import classNames, { Argument } from "classnames/dedupe";
import { TThemeVariant, useTheme } from "../../Utility/ThemeProvider";

export type TPageSpinnerType = "default" | "button";

export interface IPageSpinnerProps {
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    /**
     * applied to outer 'div' element
     */
    root?: Argument;
  };
  /** Theme for component */
  theme?: TThemeVariant;
  /** Embed type ("inside of a button", etc.) */
  type?: TPageSpinnerType;
}

const PageSpinner: FC<IPageSpinnerProps> = ({
  classes,
  theme: propsTheme = "dark",
  type = "default",
}) => {
  const theme = useTheme(propsTheme);
  return (
    <div
      data-testid="PageSpinner"
      className={classNames(
        "spinner",
        { "spinner--light": theme === "light" },
        { "spinner--btn": type === "button" },
        classes?.root,
      )}
    />
  );
};

export default PageSpinner;
